import { render, staticRenderFns } from "./template-preview-modal.vue?vue&type=template&id=efcc9a20&scoped=true"
import script from "./template-preview-modal.vue?vue&type=script&lang=js"
export * from "./template-preview-modal.vue?vue&type=script&lang=js"
import style0 from "./template-preview-modal.vue?vue&type=style&index=0&id=efcc9a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcc9a20",
  null
  
)

export default component.exports